import * as auth from './endpoints/auth';
import * as analyze from './endpoints/analyze';
import * as profile from './endpoints/profile';

export default {
    auth,
    analyze,
    profile,
};
